<template>
  <FormEmailModal
    v-if="isFormEmailModalOpen"
    @submit:success="handleSuccessSubmit"
  />

  <SuccessSubmitEmailModal v-else-if="isSuccessSubmitEmailModalOpen" />
</template>

<script setup>
import { onMounted } from 'vue';
import FormEmailModal from '@/components/email/modal/FormEmailModal.vue';
import SuccessSubmitEmailModal from '@/components/email/modal/SuccessSubmitEmailModal.vue';
import useModalHook from '@/hooks/useModal.js';

const emits = defineEmits(['registerEmail:resolved']);

const props = defineProps({
  lazy: {
    type: Boolean,
    default: false,
  },
  showInitialModalImmediate: {
    type: Boolean,
    default: false,
  },
});

const [isFormEmailModalOpen, openFormEmailModal, closeFormEmailModal] = useModalHook();
const [isSuccessSubmitEmailModalOpen, openSuccessSubmitEmailModal] = useModalHook();

const handleSuccessSubmit = async () => {
  await closeFormEmailModal({ immediate: true });

  openSuccessSubmitEmailModal({
    showImmediate: true,
    afterHideCallback: () => {
      emits('registerEmail:resolved');
    },
  });
};

const registerEmail = () => {
  openFormEmailModal({
    showImmediate: props.showInitialModalImmediate,
    afterHideCallback: () => {
      emits('registerEmail:resolved');
    },
  });
};

onMounted(() => {
  if (!props.lazy) {
    registerEmail();
  }
});

defineExpose({
  registerEmail,
});
</script>
